import { SubPages } from '../../components/sub-pages.tsx';
import { BehaviourPage } from './behaviour.tsx';
import { SkillsPage } from './skills.tsx';
import { ToolsPage } from './tools.tsx';

export function AssistantSection() {
  return (
    <SubPages
      title="Assistant"
      section="assistant"
      pages={[
        {
          id: 'behaviour',
          title: 'Behaviour',
          summary:
            'How the assistant presents itself to your users: its name, your instructions, the AI notice, links, appearance and how long chats are kept.',
          Component: BehaviourPage,
        },
        {
          id: 'tools',
          title: 'Tools',
          summary:
            'What the assistant can call in your product, and how each tool is described to it. Switch a tool off to keep the assistant away from it.',
          Component: ToolsPage,
        },
        {
          id: 'skills',
          title: 'Skills',
          summary:
            'The skills marketplace: instructions and files your users add to the assistant for particular tasks, which ones are always on, and how often each is used.',
          Component: SkillsPage,
        },
      ]}
    />
  );
}
